import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import Home from "@/pages/Home";
import ProjectDetail from "@/pages/ProjectDetail";
import Publications from "@/pages/Publications";
import LogoProposals from "@/pages/LogoProposals";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/projects/:code" element={<ProjectDetail />} />
            <Route path="/publications" element={<Publications />} />
            <Route path="/logo" element={<LogoProposals />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#1C1C1E",
              color: "#F4F4F5",
              border: "1px solid rgba(255,255,255,0.12)",
              borderRadius: 0,
              fontFamily: "'JetBrains Mono', monospace",
              fontSize: 12,
              letterSpacing: "0.04em",
            },
          }}
        />
      </LanguageProvider>
    </div>
  );
}

export default App;
